import { ExternalAppointmentsService } from '@square/dashboard-protos/models/squareup/appointments/api/external_service';
import rpc from '@square/dashboard-utilities/clients/rpc';
export default ExternalAppointmentsService.create(rpc());